import { useContext, useEffect, useRef } from 'react'
import Context from '../../common/components/utils/context'
import { environment } from "../../common/env";
import { Hero } from '../components/Hero'
import { TrustSignals } from '../components/TrustSignals'
import { Features } from '../components/Features'
import { FoundAtEarthTwinExplainer } from '../components/FoundAtEarthTwinExplainer'
import { ProofPoints } from '../components/ProofPoints'
import { RoleBasedUseCases } from '../components/RoleBasedUseCases'
import { UseCases } from '../components/UseCases'
import { Advantages } from '../components/Advantages'
import { DifferentiationTable } from '../components/DifferentiationTable'
import { FreeAppOnboarding } from '../components/FreeAppOnboarding'
import { DemoRequest } from '../components/DemoRequest'
import { Contact } from '../components/Contact'

const Index = () => {
  const context = useContext(Context);
  const homepageSections = {
    features: useRef(null),
    useCases: useRef(null),
    advantages: useRef(null),
    contact: useRef(null),
    demo: useRef(null),
  };

  useEffect(() => {
    context?.setHomepageSections(homepageSections);
    console.log(environment.Android_App_Url);
  }, []);

  return (
    <main>
        <Hero />
        <TrustSignals />
        <Features />
        <FoundAtEarthTwinExplainer />
        <RoleBasedUseCases />
        <UseCases />
        <Advantages />
        <DifferentiationTable />
        <FreeAppOnboarding />
        <DemoRequest />
        <Contact />
    </main>
  )
}

export { Index }